import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ICON } from '@core/util/icon';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { DropdownResult } from 'src/app/shared/atomic/atoms/dropdown-options/dropdown-options.component';
import { Select } from '@ngxs/store';
import {
	FireInsuranceCompaniesSearchState,
	FireInsuranceCompanyDispatch,
} from '@state/algolia-search/fire-insurance-companies-search';
import { Observable } from 'rxjs';
import { TestHooks } from './search-fire-insurance-company.hooks';
import { FireInsuranceCompany } from '@models/brokerage';

export enum DropdownSelect {
	SELECT_FIRE_INSURANCE_COMPANY = 'SELECT_FIRE_INSURANCE_COMPANY',
}

@UntilDestroy()
@Component({
	selector: 'app-search-fire-insurance-company-input',
	templateUrl: './search-fire-insurance-company.component.html',
	standalone: false,
})
export class SearchFIreInsuranceCompanyComponent implements OnInit {
	testHooks = TestHooks;
	public fireInsuranceCompanyName = '';
	public ICON = ICON;
	public showDropdown = false;
	public dropdownSelect = DropdownSelect;

	public loading = false;

	@Input() label = '';

	@Output() onFocus = new EventEmitter();
	@Output() onCreate = new EventEmitter<string>();
	@Output() onSelect = new EventEmitter<DropdownResult<FireInsuranceCompany>>();

	@Select(FireInsuranceCompaniesSearchState.getList)
	fireInsuranceCompany$: Observable<FireInsuranceCompany[]>;

	constructor(
		private fireInsuranceCompanyDispatch: FireInsuranceCompanyDispatch,
	) {}

	ngOnInit() {
		this.fireInsuranceCompany$.pipe(untilDestroyed(this)).subscribe(() => {
			this.loading = false;
		});
	}

	_onFocus() {
		this.onFocus.emit();
	}

	create() {
		this.onCreate.emit(this.fireInsuranceCompanyName);
	}

	onSelectFireInsuranceCompany = (ev: DropdownResult<FireInsuranceCompany>) => {
		if (ev.groupType === DropdownSelect.SELECT_FIRE_INSURANCE_COMPANY) {
			this.onSelect.emit(ev);
		}
	};

	search = ($event) => {
		this.loading = true;
		this.fireInsuranceCompanyDispatch.Search($event);
	};
}
